import { defineComponent as _defineComponent } from 'vue'
import { useApi } from '@/plugins/api'
import router from '@/router'
import { routes } from '@/router/routes'
import { useAuthStore, UserType } from '@/store/pinia/auth'
import LogosMap from '@/v2/components/logos/LogosMap.vue'
import { IconSlug } from '@/v2/components/ui/icon/iconMap'
import { nextTick, onBeforeMount, onMounted, ref, watch } from 'vue'
import BaseMenu, { NavMenuItem } from './partials/BaseMenu.vue'
import { usePhysicianStore } from '@/store/pinia/physician'
import { storeToRefs } from 'pinia'
import { useV2Api } from '@/plugins/api/openapi'


export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopMenu',
  setup(__props) {

const authStore = useAuthStore()
const physicianStore = usePhysicianStore()

const { extensionSubscriptions } = storeToRefs(physicianStore)

const parameterFilteredRoutes = ref(routes)
const navMenuItems = ref<NavMenuItem[]>([])

const extensionRoutes = ref<string[]>([])

watch(
  extensionSubscriptions,
  (subscriptions) => {
    extensionRoutes.value = subscriptions.flatMap((subscription) => subscription.extension?.additionalRoutes ?? [])
    menuItems()
  },
  { immediate: true },
)

function routesFromParameters() {
  let items: NavMenuItem[] = parameterFilteredRoutes.value
    .filter((route) => !route.meta?.admin)
    .filter((route) => (route.name === 'screening' && authStore.userHasScreenings) || route.name !== 'screening')
    .filter((route) => !route.meta?.hidden && !route.meta?.singlePage)
    .map((route) => ({
      path: route.path!,
      name: route.name!,
      title: route.meta?.title!,
      icon: route.meta?.icon as IconSlug,
      tooltip: route.meta?.tooltip,
    }))

  navMenuItems.value = items
  nextTick()
}

function menuItems() {
  let items: NavMenuItem[] = []

  if (authStore.userType !== UserType.ADMIN && parameterFilteredRoutes.value.length > 0) {
    routesFromParameters()
    return
  }

  items = routes
    .filter((route) => route.path !== '/' && !route.meta?.hidden)
    .filter((route) => route.meta?.public || (authStore.userType === UserType.ADMIN && !route.meta?.hideAdmin))
    .map((route) => ({
      path: route.path!,
      name: route.name!,
      title: route.meta?.title!,
      icon: route.meta?.icon as IconSlug,
    }))

  navMenuItems.value = items

  return
}

function goHome() {
  router.push({ name: 'home' })
}

onMounted(() => {
  menuItems()
})

return { __sfc: true,authStore, physicianStore, extensionSubscriptions, parameterFilteredRoutes, navMenuItems, extensionRoutes, routesFromParameters, menuItems, goHome, LogosMap, BaseMenu }
}

})